module.exports = __webpack_public_path__ + "img/home-line2-img1.e25d9407.png";